var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pmlst-outcome"}},[_c('div',{staticClass:"pmlst-outcome-wrapper"},[_c('div',{staticClass:"pmlst-outcome-extra-wrapper"},[_c('div',{staticClass:"outcome"},[_c('monistat-symptom-checker-outcome',{attrs:{"outcome":_vm.outcome}})],1),_c('div',{staticClass:"actions"},[_c('restart-button',{attrs:{"restart":{
            icon: 'fas fa-sync',
            text: 'Restablecer el verificador de síntomas'
          }}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }